import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex whitespace-nowrap items-center gap-2" }
const _hoisted_2 = ["innerHTML"]

import { SMSShortMessage } from '@/inbox/composition';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	message: SMSShortMessage;
	isUnread: boolean;
};



function getBody() {
	const div = document.createElement('div');
	div.innerHTML = props.message?.content?.body;
	return div.textContent || div.innerText || '';
}

const body = computed(() => getBody());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["whitespace-nowrap overflow-hidden overflow-ellipsis", 
				__props.isUnread
					? 'text-inbox-gray-theme-600 font-medium'
					: 'text-inbox-gray-theme-600 font-light'
			])
    }, [
      (
					__props.message.content?.direction ===
					'outgoing'
				)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Outbound ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Inbound")
          ], 64)),
      _createTextVNode(" sms "),
      (__props.message.content?.body)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["ml-2 whitespace-nowrap", 
					__props.isUnread
						? 'font-light text-inbox-gray-theme-600'
						: 'text-inbox-gray-theme-600  font-light'
				]),
            innerHTML: _unref(body)
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})